import * as BECaller from '../../util/apiCaller';
import { getInfo } from '../Auth/AuthActions';
import { setError, setSuccessMessage } from '../App/ErrorsActions';

export const PLANS = 'SUBSCRIPTION_PLANS_DATA',
  REQ_SENT = 'SUBSCRIPTION_REQUEST_SENT',
  REQ_FAILED = 'SUBSCRIPTION_REQUEST_FAILED',
  ESTIMATE = 'SUBSCRIPTION_ESTIMATE',
  UPDATE_STEP = 'SUBSCRIPTION_UPDATE_STEP',
  LOADING = 'SUBSCRIPTION_PAYMENT_LOADING';

function success(data) {
  return {
    type: PLANS,
    plans: data,
  };
}

function failedActivation(err) {
  return {
    type: REQ_FAILED,
    error: err,
  };
}

function successActivation() {
  return {
    type: REQ_SENT,
  };
}

export function setLoading(value) {
  return { type: LOADING, value };
}

export function error(err, opt) {
  return setError(err, opt);
}

export function clearEstimation() {
  return { type: ESTIMATE, data: {} };
}

export function updateStepData(model) {
  return {
    type: UPDATE_STEP,
    model,
  };
}

export function getPlans() {
  return (dispatch, getState) => {
    const { plans } = getState().subscription;
    if (plans.annual) {
      return true;
    }

    BECaller.api(`billing/plans`, 'get').then(
      (data) => {
        dispatch(success(data));
      },
      (err) => {
        dispatch(setError(err));
      }
    );
  };
}

export function saveBillingInfo(model) {
  return (dispatch) => {
    return BECaller.api(`billing/customer`, 'put', model).then(
      (data) => {
        return Promise.resolve();
      },
      (err) => {
        dispatch(setError(err));
        return Promise.reject();
      }
    );
  };
}

export function requestActivation(model) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return BECaller.api(`billing/request`, 'post', model).then(
      (data) => {
        dispatch(setSuccessMessage('Your subscription has been activated successfully'));
        dispatch(successActivation());
        return dispatch(getInfo());
      },
      (err) => {
        if (err.data && err.data.payment) {
          dispatch(setError(err.data.payment.error.message));
        } else {
          dispatch(setError("We weren't able to process your payment. Please try again or use a different card."));
        }
        dispatch(failedActivation(err));
      }
    );
  };
}

export function requestUpgrade(model) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return BECaller.api(`billing/upgrade`, 'post', model).then(
      (data) => {
        dispatch(setSuccessMessage('Your plan has been changed successfully'));
        dispatch(successActivation());
        return dispatch(getInfo());
      },
      (err) => {
        if (err.data && err.data.payment) {
          dispatch(setError(err.data.payment.error.message));
        } else {
          dispatch(setError("We weren't able to process your payment. Please try again or use a different card."));
        }
        dispatch(failedActivation(err));
      }
    );
  };
}

export function estimate(model) {
  return (dispatch) => {
    return BECaller.api(`billing/estimate`, 'post', model).then(
      (data) => {
        if (data.discounts && data.discounts.length > 0) {
          dispatch(setSuccessMessage('Coupon applied successfully'));
        }
        dispatch({ type: ESTIMATE, data });
        dispatch(updateStepData(model));

        return Promise.resolve(data);
      },
      (err) => {
        dispatch(setError(err));
        return Promise.reject(err);
      }
    );
  };
}
